import React, { Component } from "react";
import MainLayout from "../../components/layouts/MainLayout";
import { withRouter } from "../../hoc/withRouter";
import { Button, DatePicker, Dropdown, Form, Input, Menu, message, Modal, Select, Table, Tag, Tooltip } from "antd";
import { orderService } from "../../services/otodisApi/OrderService";
import { ListOrderStates } from "./types/ListClosedOrderTypes";
import { CloudSyncOutlined, CopyOutlined, EditOutlined, ScheduleOutlined } from "@ant-design/icons";
import withAuth from "../../hoc/withAuth";
import moment from "moment";
import UpdateOwnerOrder from "../../components/order/UpdateOwnerOrder";
import ModalDetailOrder from "../../components/order/ModalDetailOrder";

export interface HomeProps {}

class ListClosedOrder extends Component<HomeProps & any, ListOrderStates> {
  private readonly initState!: ListOrderStates;
  private tableColumn: any = [
    {
      title: "Kode Order",
      dataIndex: "order_code",
      width: 180,
      render: (value: string, row: []) => {
        return (
          <React.Fragment>
            <span className={`font-90-link`} onClick={(event) => this.showDetail(row)}>
              {value}
            </span>
            &nbsp; &nbsp;
            <Tooltip title="Click untuk copy kode stock unit" color={"cyan"}>
              <CopyOutlined className={"small-avatar-link"} onClick={(event) => this.copyToClipboard(value)} />
            </Tooltip>
          </React.Fragment>
        );
      },
    },
    {
      title: "Kode Offer",
      dataIndex: "amh_order_number",
      width: 180,
      render: (value: string, row: []) => {
        return (
          <React.Fragment>
            <span className={`font-90-link`}>{value}</span>
            &nbsp; &nbsp;
            <Tooltip title="Click untuk copy" color={"cyan"}>
              <CopyOutlined className={"small-avatar-link"} onClick={(event) => this.copyToClipboard(value)} />
            </Tooltip>
          </React.Fragment>
        );
      },
    },
    {
      title: "Metode",
      dataIndex: "order_payment_method",
      width: 50,
      render: (value: string) => {
        return value === "CREDIT" ? <Tag color="success">CREDIT</Tag> : <Tag color="geekblue">CASH</Tag>;
      },
    },
    {
      title: "Stock / Kendaraan",
      dataIndex: "vehicle_variant_name",
      width: 150,
      render: (value: string, row: any) => {
        return <span className={`font-90`}>{`${row?.stock_unit_code} \n ${row?.vehicle_variant_name} - ${row?.vehicle_color_name}`}</span>;
      },
    },
    {
      title: "Nomor Mesin | Nomor Rangka",
      dataIndex: "vehicle_engine_number",
      width: 100,
      render: (value: string, row: any) => {
        const showInNosin = row?.stock_condition === "SECOND" ? row?.vehicle_license_plate + " - " + row?.vehicle_engine_number : row?.vehicle_engine_number;
        const showInNoChassis = row?.stock_condition === "SECOND" ? row?.vehicle_license_plate + " - " + row?.vehicle_chassis_number : row?.vehicle_chassis_number;
        return <span className={`font-90`}>{`${showInNosin} | ${showInNoChassis}`}</span>;
      },
    },
    {
      title: "Makreting",
      dataIndex: "marketing_name",
      width: 100,
      render: (value: number, row: any) => {
        return <span className={`font-90`}>{value}</span>;
      },
    },
    {
      title: "Nama BPKB & Nama Konsumen",
      dataIndex: "customer_doc_name",
      width: 150,
      render: (value: string, row: any) => {
        return (
          <React.Fragment>
            <span style={{ fontSize: "80%" }}>{`${row.customer_doc_name}`}</span>
            <br />
            <span style={{ fontSize: "80%" }}>{`${row.customer_name}`}</span>
          </React.Fragment>
        );
      },
    },
    {
      title: "Tanggal Closing",
      dataIndex: "order_closing_date",
      width: 100,
      render: (value: number, row: any) => {
        return <span className={`font-90`}>{value}</span>;
      },
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 100,
      render: (row: any) => {
        if (row.order_status !== "CLOSED") {
          return null; // Mengembalikan null untuk tidak menampilkan menu
        }
        const menu = (
          <Menu>
            <Menu.Item key={2}>
              <span onClick={() => this.onSetDataUpdate(row)} style={{ cursor: "pointer" }}>
                {" "}
                <EditOutlined /> Edit Data
              </span>
            </Menu.Item>
          </Menu>
        );

        return (
          <React.Fragment>
            <span className={`font-90`}>
              <Dropdown overlay={menu} placement="bottomLeft" arrow>
                <Button size={"small"} type={"primary"}>
                  {" "}
                  <ScheduleOutlined /> Aksi
                </Button>
              </Dropdown>
            </span>
          </React.Fragment>
        );
      },
    },
  ];

  constructor(props: (HomeProps & any) | any) {
    super(props);

    this.initState = {
      processing: false,
      processingFetchTableData: false,
      dealerCode: props.match.params.dealerCode.replace(/-/g, "#"),
      pageSize: 100,
      showModalDetailOrder: false,
      dataOrder: [],
      rowDetailOrder: [],

      filterType: "DATE",
      filterOrderCode: "",
      filterEngineNumber: "",
      filterStartDate: moment().clone().format("YYYY-MM-DD"),
      filterEndDate: moment().clone().format("YYYY-MM-DD"),
      filterStatus: "CLOSED",
      showFilterDate: true,
      showFilterEngineNumber: false,
      showFilterOrderCode: false,

      chosenOrderData: {},
      showModalUpdateOwner: false,
      showModalImage: false,
      modalImageUrl: "",
    };
    this.state = { ...this.initState };
  }

  copyToClipboard = async (data: any) => {
    await navigator.clipboard.writeText(data);
  };

  closeModalDetailOrder = () => {
    this.setState({
      rowDetailOrder: [],
      showModalDetailOrder: false,
    });
  };

  showDetail = async (data: any) => {
    // console.log(data);
    await this.promisedSetState({
      rowDetailOrder: data,
      showModalDetailOrder: true,
    });
  };

  onCloseEditModal = () => {
    this.setState({
      showModalUpdateOwner: false,
    });
    this.fetchOrderData();
  };

  onSetDataUpdate = (row: any) => {
    this.setState({
      chosenOrderData: row,
      showModalUpdateOwner: true,
    });
  };

  onDealerChange = async (data: any) => {
    await this.promisedSetState({
      processingFetchTableData: true,
      dealerCode: data.value,
    });
  };

  fetchOrderData = async () => {
    await this.promisedSetState({
      dataOrder: [],
      processingFetchTableData: true,
    });
    let filter = {};
    if (this.state.showFilterOrderCode === true) {
      filter = {
        dealerCode: this.state.dealerCode,
        orderCode: this.state.filterOrderCode,
      };
    } else if (this.state.showFilterEngineNumber === true) {
      filter = {
        vehicleEngineNumber: this.state.filterEngineNumber,
      };
    } else {
      filter = {
        dealerCode: this.state.dealerCode,
        dateStart: moment(this.state.filterStartDate).format("YYYY-MM-DD"),
        dateEnd: moment(this.state.filterEndDate).format("YYYY-MM-DD"),
        dataType: "create_date",
        statusOrder: this.state.filterStatus,
      };
    }

    orderService
      .getOrder(filter)
      .then(async (value) => {
        await this.promisedSetState({
          dataOrder: value.data.data,
          processingFetchTableData: false,
        });
      })
      .catch(async (reason) => {
        await this.promisedSetState({
          dataOrder: [],
          processingFetchTableData: false,
        });
        message.error("Data Tidak Ditemukan");
      });
  };

  onChangeTable = (pagination: any, filters: any, sorter: any) => {
    // console.log(pagination);
    // console.log(filters);
    // console.log(sorter);
    if (pagination?.pageSize) {
      this.setState({
        pageSize: pagination?.pageSize,
      });
    }
  };

  onWarehouseStartDate = (data: any) => {
    this.setState({
      filterStartDate: data,
    });
  };

  onWarehouseEndDate = (data: any) => {
    this.setState({
      filterEndDate: data,
    });
  };

  onFieldChange = <T extends keyof Pick<any, "filterType" | "filterOrderCode" | "filterEngineNumber" | "filterStartDate" | "filterEndDate" | "filterStatus">>(target: T, value: any) => {
    const currentState: any = { ...this.state };
    switch (target) {
      case "filterType":
        currentState.filterType = value;
        if (value === "DATE") {
          currentState.showFilterDate = true;
          currentState.showFilterEngineNumber = false;
          currentState.showFilterOrderCode = false;
        } else if (value === "ORDER_CODE") {
          currentState.showFilterDate = false;
          currentState.showFilterEngineNumber = false;
          currentState.showFilterOrderCode = true;
        } else if (value === "ENGINE_NUMBER") {
          currentState.showFilterDate = false;
          currentState.showFilterEngineNumber = true;
          currentState.showFilterOrderCode = false;
        }
        break;
      case "filterOrderCode":
        currentState.filterOrderCode = value;
        break;
      case "filterEngineNumber":
        currentState.filterEngineNumber = value;
        break;
      case "filterStartDate":
        currentState.filterStartDate = value;
        break;
      case "filterEndDate":
        currentState.filterEndDate = value;
        break;
      case "filterStatus":
        currentState.filterStatus = value;
        break;
    }
    this.setState({
      ...currentState,
    });
  };

  promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

  render() {
    return (
      <React.Fragment>
        <MainLayout noPadNoMar={true} onChangeDealer={this.onDealerChange} breadcrumbPath={`Order`} breadcrumbMenu={`List Order`} defaultSelectedKeys={["m-order"]} defaultOpenKeys={["sm-order"]}>
          <div style={{ padding: 20 }}>
            <Form layout={`inline`}>
              <Form.Item className={"padTop-10"} style={{ minWidth: 140 }}>
                <i className={`small-text-grey`}>Filter By</i>
                <Select showSearch placeholder="Filter" optionFilterProp="children" onChange={(value) => this.onFieldChange("filterType", value)} value={this.state.filterType}>
                  <Select.Option key={`DATE`} value={`DATE`}>{`Tanggal`}</Select.Option>
                  <Select.Option key={`ORDER_CODE`} value={`ORDER_CODE`}>{`Kode Order`}</Select.Option>
                  <Select.Option key={`ENGINE_NUMBER`} value={`ENGINE_NUMBER`}>{`Nomor Mesin`}</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item className={"padTop-10"} style={{ display: this.state.showFilterDate ? "block" : "none" }}>
                <i className={`small-text-grey`}>Tanggal</i>
                <br />
                <DatePicker defaultValue={moment(this.state.filterStartDate, "YYYY-MM-DD")} onChange={(event) => this.onFieldChange("filterStartDate", event)} format={"YYYY-MM-DD"} />
              </Form.Item>
              <Form.Item className={"padTop-10"} style={{ display: this.state.showFilterDate ? "block" : "none" }}>
                <i className={`small-text-grey`}>Tgl Akhir</i>
                <br />
                <DatePicker defaultValue={moment(this.state.filterEndDate, "YYYY-MM-DD")} onChange={(event) => this.onFieldChange("filterEndDate", event)} format={"YYYY-MM-DD"} />
              </Form.Item>
              <Form.Item className={"padTop-10"} style={{ minWidth: 140, display: this.state.showFilterDate ? "block" : "none" }}>
                <i className={`small-text-grey`}>Status</i>
                <Select showSearch placeholder="Pilih Metide" optionFilterProp="children" onChange={(value) => this.onFieldChange("filterStatus", value)} value={this.state.filterStatus}>
                  <Select.Option key={`CLOSED`} value={`CLOSED`}>{`Closed`}</Select.Option>
                  <Select.Option key={`DELIVERED`} value={`DELIVERED`}>{`Delivered`}</Select.Option>
                  <Select.Option key={`CANCELED`} value={`CANCELED`}>{`Canceled`}</Select.Option>
                  <Select.Option key={`FINISHED`} value={`FINISHED`}>{`Finished`}</Select.Option>
                  <Select.Option key={`UNFINISHED`} value={`UNFINISHED`}>{`UnFinished`}</Select.Option>
                  <Select.Option key={`RETUR`} value={`RETUR`}>{`Retur`}</Select.Option>
                </Select>
              </Form.Item>

              <Form.Item className={"padTop-10 "} style={{ minWidth: 120, display: this.state.showFilterOrderCode ? "block" : "none" }}>
                <i className={`small-text-grey`}>Order Code</i>
                <Input value={this.state.filterOrderCode} onChange={(event) => this.onFieldChange("filterOrderCode", event.target.value)} placeholder="Order Code" />
              </Form.Item>

              <Form.Item className={"padTop-10 filterEngineNumber"} style={{ minWidth: 120, display: this.state.showFilterEngineNumber ? "block" : "none" }}>
                <i className={`small-text-grey`}>Nomor Mesin</i>
                <Input value={this.state.filterEngineNumber} onChange={(event) => this.onFieldChange("filterEngineNumber", event.target.value)} placeholder="Nomor Mesin" />
              </Form.Item>

              <Form.Item className={"padTop-20"}>
                <Button onClick={this.fetchOrderData} type="primary" icon={<CloudSyncOutlined />}>
                  {" "}
                  Go{" "}
                </Button>
              </Form.Item>
            </Form>
          </div>
          <br />

          <Table
            rowKey={"order_code"}
            size={"small"}
            scroll={{ x: "calc(500px + 50%)" }}
            loading={this.state.processingFetchTableData}
            columns={this.tableColumn}
            dataSource={this.state.dataOrder}
            pagination={{ pageSize: this.state.pageSize }}
            onChange={this.onChangeTable}
          />
        </MainLayout>
        <Modal open={this.state.showModalUpdateOwner} title="Update Owner KTP" onCancel={() => this.setState({ showModalUpdateOwner: false })} footer={[]}>
          <UpdateOwnerOrder onCloseUpdateOwnerIdCardProps={this.onCloseEditModal} OrderData={this.state.chosenOrderData} time={Math.floor(+new Date() / 1000)} />
        </Modal>
        <ModalDetailOrder kodeOrder={"aaaa"} dataOrder={this.state.rowDetailOrder} visible={this.state.showModalDetailOrder} onClose={this.closeModalDetailOrder} />
      </React.Fragment>
    );
  }
}

export default withAuth(withRouter(ListClosedOrder), 6);
